import {
  PreferredContactMethodSchema,
  type PreferredContactMethod as GeneratedPreferredContactMethod
} from '~/services/api/generated'

// Mirrors backend App\Enums\PreferredContactMethod

export type PreferredContactMethod = GeneratedPreferredContactMethod

export const PreferredContactMethod = {
  EMAIL: PreferredContactMethodSchema.enum.email,
  PHONE: PreferredContactMethodSchema.enum.phone
} satisfies Record<string, GeneratedPreferredContactMethod>

export const PreferredContactMethodValues: readonly GeneratedPreferredContactMethod[] = [
  PreferredContactMethodSchema.enum.email,
  PreferredContactMethodSchema.enum.phone
]
